const types = {
  UPDATE_FORM_JUSTIFICATION: '@employee/formJustification/update',
  RESET_FORM_JUSTIFICATION: '@employee/formJustification/reset',
};

export default types;
